export const APPOINTMENT_STATUS = {
  scheduled: { label: "Запланирован", tone: "blue" },
  confirmed: { label: "Подтверждён", tone: "green" },
  in_progress: { label: "Идёт занятие", tone: "purple" },
  completed: { label: "Завершён", tone: "gray" },
  cancelled: { label: "Отменён", tone: "red" },
  no_show: { label: "Не явился", tone: "orange" },
};

export function statusLabel(status) {
  return APPOINTMENT_STATUS[status]?.label || status;
}

export const WEEKDAYS = [
  { id: 1, short: "Пн", label: "Понедельник" },
  { id: 2, short: "Вт", label: "Вторник" },
  { id: 3, short: "Ср", label: "Среда" },
  { id: 4, short: "Чт", label: "Четверг" },
  { id: 5, short: "Пт", label: "Пятница" },
  { id: 6, short: "Сб", label: "Суббота" },
  { id: 0, short: "Вс", label: "Воскресенье" },
];

export function formatDateRu(iso, opts = {}) {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "numeric",
    month: "long",
    ...opts,
  });
}

export function formatTimeRu(iso) {
  return new Date(iso).toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function toDateInputValue(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
